import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { IconBackArrow, IconCourse, IconDesign, IconDocuments, IconGhost, IconHome, IconRefabricAcademyLogo, IconSupport2, IconTrain } from "icons";
import { useNavigate } from "react-router-dom";
import { PATHS } from "router/config/paths";
import ContactUsForm from "components/ContactUsModal";

const Divider = () => <div className="w-full h-[1px] flex-shrink-0 bg-grey-light" />;

const AcademyMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [showContactUsModal, setShowContactUsModal] = React.useState(false);

  const PageItem = ({ title, Icon, isSelected, onClick }: { title: string; Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>; isSelected: boolean; onClick?: () => void }) => {
    return (
      <div className={clsx("cursor-pointer flex items-center gap-2 py-2 px-1", isSelected && "pl-0 bg-gradient-to-r from-[rgba(232,128,83,0.10)] to-[rgba(232,128,83,0.00)]")} onClick={onClick}>
        {isSelected && <div className="w-[3px] h-[20px] bg-orange flex-shrink-0" />}
        <Icon className="w-[18px] h-[18px] flex-shrink-0" />
        <span className="font-satoshi text-[17px] font-medium text-black tracking-[-0.34px] leading-[120%]">{title}</span>
      </div>
    );
  };

  const RedirectItem = ({ title, Icon, link, onClick }: { title: string; Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>; link?: string; onClick?: () => void }) => {
    return (
      <a className="cursor-pointer flex items-center gap-2 py-2 px-1" href={link} target="_blank" rel="noopener noreferrer" onClick={onClick}>
        <Icon className="w-[18px] h-[18px] flex-shrink-0" />
        <span className="w-full font-satoshi text-[17px] font-medium text-black tracking-[-0.34px] leading-[120%]">{title}</span>
        <IconBackArrow className="rotate-[135deg] text-grey flex-shrink-0" />
      </a>
    );
  };

  return (
    <div className="sticky z-50 top-5 left-0 flex flex-col h-fit gap-3 p-4 rounded-xl border border-grey-light w-[240px]">
      <IconRefabricAcademyLogo />

      <Divider />

      <span className="font-satoshi text-[11px] font-bold text-grey uppercase tracking-[0.55px] leading-[140%]">{t("academy:menu.section_learn")}</span>
      <div className="flex flex-col gap-1">
        <PageItem
          title={t("academy:menu.home")}
          Icon={IconHome}
          isSelected={window.location.pathname === PATHS.ACADEMY_HOME}
          onClick={() => {
            navigate(PATHS.ACADEMY_HOME);
          }}
        />
        <PageItem
          title={t("academy:menu.all_courses")}
          Icon={IconCourse}
          isSelected={window.location.pathname === PATHS.ACADEMY_ALL_COURSES}
          onClick={() => {
            navigate(PATHS.ACADEMY_ALL_COURSES);
          }}
        />
        <RedirectItem title={t("academy:menu.explore_features")} Icon={IconDocuments} link="https://explorefeatures.refabric.com/" />
      </div>

      <Divider />

      <span className="font-satoshi text-[11px] font-bold text-grey uppercase tracking-[0.55px] leading-[140%]">{t("academy:menu.section_support")}</span>
      <div className="flex flex-col gap-1">
        {/* <RedirectItem title="Community" Icon={IconForum} /> */}

        {showContactUsModal && <ContactUsForm show={showContactUsModal} onClose={() => setShowContactUsModal(false)} type="academy_get_help" />}

        <RedirectItem
          title={t("academy:menu.get_help")}
          Icon={IconSupport2}
          onClick={() => {
            setShowContactUsModal(true);
          }}
        />
      </div>

      <Divider />

      <span className="font-satoshi text-[11px] font-bold text-grey uppercase tracking-[0.55px] leading-[140%]">{t("academy:menu.section_designing")}</span>
      <div className="flex flex-col gap-1">
        <RedirectItem title={t("academy:menu.new_design")} Icon={IconDesign} onClick={() => navigate("/design")} />
        <RedirectItem title={t("academy:menu.new_training")} Icon={IconTrain} onClick={() => navigate(PATHS.MOODBOARDS_MY)} />
        <RedirectItem title={t("academy:menu.new_photoshoot")} Icon={IconGhost} onClick={() => navigate("/photoshoot")} />
      </div>

      <Divider />

      <button className="flex items-center gap-2">
        <IconBackArrow className="text-purple" />
        <span
          className="font-satoshi text-[17px] underline underline-offset-4 font-medium text-purple tracking-[-0.34px] leading-[120%] flex items-center gap-2"
          onClick={() => {
            navigate("/");
          }}
        >
          {t("academy:menu.back_to_refabric")}
        </span>
      </button>
    </div>
  );
};

export default AcademyMenu;
